import React from "react";

const Plus = ({ active }) => {
  const primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--primary")
    ?.trim();
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.6352 4.00958C11.5692 3.44119 11.0862 3 10.5001 3C9.86888 3 9.3572 3.51167 9.3572 4.14286V9.85715H3.64286L3.50958 9.86484C2.94119 9.93086 2.5 10.4139 2.5 11C2.5 11.6312 3.01167 12.1429 3.64286 12.1429H9.3572V17.8571L9.36489 17.9904C9.43091 18.5588 9.91396 19 10.5001 19C11.1312 19 11.6429 18.4883 11.6429 17.8571V12.1429H17.3571L17.4904 12.1352C18.0588 12.0692 18.5 11.5861 18.5 11C18.5 10.3688 17.9883 9.85715 17.3571 9.85715H11.6429V4.14286L11.6352 4.00958Z"
        fill="white"
      />
    </svg>
  );
};

export default Plus;
